import styled from 'styled-components'

const ContentContainer = styled.div`
  display: block;
  margin: auto;
  padding: 20px;
`

export { ContentContainer }
